'use client';
/**
 * Проверяет, доступен ли `window.matchMedia` (media-запросы) в текущем контексте.
 */ const supportsMatchMedia = ()=>'matchMedia' in (window || {});

export { supportsMatchMedia };
//# sourceMappingURL=supportsMatchMedia.js.map
